namespace $.$$ {
	export class $eve_app_page_components_text extends $.$eve_app_page_components_text {}
}
